import { explatPlatform, explatTypes } from '@1debit/explat';

import loggerHelper, { LOG_LEVELS } from 'utils/logger/loggerHelper';

export const initExPlat = () => {
  try {
    explatPlatform.init({
      debugMode: { log: true, raiseError: true },
      urls: {
        rest: '../',
      },
    });
  } catch (err) {
    loggerHelper({
      level: LOG_LEVELS.ERROR,
      message: 'ExPlat initialization failed',
      info: err,
    });
  }
};

/*
fetchAndStoreVariants: gets all variant results for given unit type and cache the values to localstorage

unitId: value of anonymousId or userId 
isAnonymousId: boolean describing whether or not unitId is an anonymousId value. 
*/

export async function fetchAndStoreVariants({ unitId, isAnonymousId }) {
  let unitType = explatTypes.UnitType.UNIT_TYPE_USER;
  if (isAnonymousId) {
    unitType = explatTypes.UnitType.UNIT_TYPE_ANONYMOUS;
  }
  return explatPlatform.fetchAndStoreVariants(
    unitId,
    unitType,
    explatTypes.Service.EXPERIMENT_SERVICE_ENROLLMENT_CLIENT
  );
}
